// Generated by purs version 0.15.15
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var VatAIsSymbol = {
    reflectSymbol: function () {
        return "VatA";
    }
};
var VatBIsSymbol = {
    reflectSymbol: function () {
        return "VatB";
    }
};
var VatCIsSymbol = {
    reflectSymbol: function () {
        return "VatC";
    }
};
var VatDIsSymbol = {
    reflectSymbol: function () {
        return "VatD";
    }
};
var VatEIsSymbol = {
    reflectSymbol: function () {
        return "VatE";
    }
};
var VatFIsSymbol = {
    reflectSymbol: function () {
        return "VatF";
    }
};
var VatGIsSymbol = {
    reflectSymbol: function () {
        return "VatG";
    }
};
var VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumptionIsSymbol = {
    reflectSymbol: function () {
        return "VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption";
    }
};
var VatSkNonAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol = {
    reflectSymbol: function () {
        return "VatSkNonAlcoholicBeveragesIntendedForHumanConsumption";
    }
};
var VatSkAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol = {
    reflectSymbol: function () {
        return "VatSkAlcoholicBeveragesIntendedForHumanConsumption";
    }
};
var VatSkSeparateFoodPackagingIsSymbol = {
    reflectSymbol: function () {
        return "VatSkSeparateFoodPackaging";
    }
};
var VatSkTransportIsSymbol = {
    reflectSymbol: function () {
        return "VatSkTransport";
    }
};
var VatSkWithoutIsSymbol = {
    reflectSymbol: function () {
        return "VatSkWithout";
    }
};
var VatSkExemptIsSymbol = {
    reflectSymbol: function () {
        return "VatSkExempt";
    }
};
var genericTopConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments);
var genericBottomConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments);
var genericBottomSum = /* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(genericBottomConstructor);
var genericEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments);
var genericEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
var genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum);
var genericBoundedEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments);
var genericBoundedEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(genericBoundedEnumConstructor);
var genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor)))))))))))));
var VatA = /* #__PURE__ */ (function () {
    function VatA() {

    };
    VatA.value = new VatA();
    return VatA;
})();
var VatB = /* #__PURE__ */ (function () {
    function VatB() {

    };
    VatB.value = new VatB();
    return VatB;
})();
var VatC = /* #__PURE__ */ (function () {
    function VatC() {

    };
    VatC.value = new VatC();
    return VatC;
})();
var VatD = /* #__PURE__ */ (function () {
    function VatD() {

    };
    VatD.value = new VatD();
    return VatD;
})();
var VatE = /* #__PURE__ */ (function () {
    function VatE() {

    };
    VatE.value = new VatE();
    return VatE;
})();
var VatF = /* #__PURE__ */ (function () {
    function VatF() {

    };
    VatF.value = new VatF();
    return VatF;
})();
var VatG = /* #__PURE__ */ (function () {
    function VatG() {

    };
    VatG.value = new VatG();
    return VatG;
})();
var VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption = /* #__PURE__ */ (function () {
    function VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption() {

    };
    VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption.value = new VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption();
    return VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption;
})();
var VatSkNonAlcoholicBeveragesIntendedForHumanConsumption = /* #__PURE__ */ (function () {
    function VatSkNonAlcoholicBeveragesIntendedForHumanConsumption() {

    };
    VatSkNonAlcoholicBeveragesIntendedForHumanConsumption.value = new VatSkNonAlcoholicBeveragesIntendedForHumanConsumption();
    return VatSkNonAlcoholicBeveragesIntendedForHumanConsumption;
})();
var VatSkAlcoholicBeveragesIntendedForHumanConsumption = /* #__PURE__ */ (function () {
    function VatSkAlcoholicBeveragesIntendedForHumanConsumption() {

    };
    VatSkAlcoholicBeveragesIntendedForHumanConsumption.value = new VatSkAlcoholicBeveragesIntendedForHumanConsumption();
    return VatSkAlcoholicBeveragesIntendedForHumanConsumption;
})();
var VatSkSeparateFoodPackaging = /* #__PURE__ */ (function () {
    function VatSkSeparateFoodPackaging() {

    };
    VatSkSeparateFoodPackaging.value = new VatSkSeparateFoodPackaging();
    return VatSkSeparateFoodPackaging;
})();
var VatSkTransport = /* #__PURE__ */ (function () {
    function VatSkTransport() {

    };
    VatSkTransport.value = new VatSkTransport();
    return VatSkTransport;
})();
var VatSkWithout = /* #__PURE__ */ (function () {
    function VatSkWithout() {

    };
    VatSkWithout.value = new VatSkWithout();
    return VatSkWithout;
})();
var VatSkExempt = /* #__PURE__ */ (function () {
    function VatSkExempt() {

    };
    VatSkExempt.value = new VatSkExempt();
    return VatSkExempt;
})();
var eqVatRate = {
    eq: function (x) {
        return function (y) {
            if (x instanceof VatA && y instanceof VatA) {
                return true;
            };
            if (x instanceof VatB && y instanceof VatB) {
                return true;
            };
            if (x instanceof VatC && y instanceof VatC) {
                return true;
            };
            if (x instanceof VatD && y instanceof VatD) {
                return true;
            };
            if (x instanceof VatE && y instanceof VatE) {
                return true;
            };
            if (x instanceof VatF && y instanceof VatF) {
                return true;
            };
            if (x instanceof VatG && y instanceof VatG) {
                return true;
            };
            if (x instanceof VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption && y instanceof VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption) {
                return true;
            };
            if (x instanceof VatSkNonAlcoholicBeveragesIntendedForHumanConsumption && y instanceof VatSkNonAlcoholicBeveragesIntendedForHumanConsumption) {
                return true;
            };
            if (x instanceof VatSkAlcoholicBeveragesIntendedForHumanConsumption && y instanceof VatSkAlcoholicBeveragesIntendedForHumanConsumption) {
                return true;
            };
            if (x instanceof VatSkSeparateFoodPackaging && y instanceof VatSkSeparateFoodPackaging) {
                return true;
            };
            if (x instanceof VatSkTransport && y instanceof VatSkTransport) {
                return true;
            };
            if (x instanceof VatSkWithout && y instanceof VatSkWithout) {
                return true;
            };
            if (x instanceof VatSkExempt && y instanceof VatSkExempt) {
                return true;
            };
            return false;
        };
    }
};
var ordVatRate = {
    compare: function (x) {
        return function (y) {
            if (x instanceof VatA && y instanceof VatA) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatA) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatA) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatB && y instanceof VatB) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatB) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatB) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatC && y instanceof VatC) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatC) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatC) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatD && y instanceof VatD) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatD) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatD) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatE && y instanceof VatE) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatE) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatE) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatF && y instanceof VatF) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatF) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatF) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatG && y instanceof VatG) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatG) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatG) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption && y instanceof VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatSkNonAlcoholicBeveragesIntendedForHumanConsumption && y instanceof VatSkNonAlcoholicBeveragesIntendedForHumanConsumption) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatSkNonAlcoholicBeveragesIntendedForHumanConsumption) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatSkNonAlcoholicBeveragesIntendedForHumanConsumption) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatSkAlcoholicBeveragesIntendedForHumanConsumption && y instanceof VatSkAlcoholicBeveragesIntendedForHumanConsumption) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatSkAlcoholicBeveragesIntendedForHumanConsumption) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatSkAlcoholicBeveragesIntendedForHumanConsumption) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatSkSeparateFoodPackaging && y instanceof VatSkSeparateFoodPackaging) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatSkSeparateFoodPackaging) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatSkSeparateFoodPackaging) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatSkTransport && y instanceof VatSkTransport) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatSkTransport) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatSkTransport) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatSkWithout && y instanceof VatSkWithout) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof VatSkWithout) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof VatSkWithout) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof VatSkExempt && y instanceof VatSkExempt) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.VatRate (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqVatRate;
    }
};
var genericVatRate = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return VatA.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return VatB.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return VatC.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return VatD.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return VatE.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return VatF.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return VatG.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return VatSkNonAlcoholicBeveragesIntendedForHumanConsumption.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return VatSkAlcoholicBeveragesIntendedForHumanConsumption.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return VatSkSeparateFoodPackaging.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
            return VatSkTransport.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
            return VatSkWithout.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))))))) {
            return VatSkExempt.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.VatRate (line 17, column 1 - line 17, column 69): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof VatA) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof VatB) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof VatC) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof VatD) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof VatE) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof VatF) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof VatG) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
        };
        if (x instanceof VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
        };
        if (x instanceof VatSkNonAlcoholicBeveragesIntendedForHumanConsumption) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))));
        };
        if (x instanceof VatSkAlcoholicBeveragesIntendedForHumanConsumption) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))));
        };
        if (x instanceof VatSkSeparateFoodPackaging) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
        };
        if (x instanceof VatSkTransport) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))));
        };
        if (x instanceof VatSkWithout) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))));
        };
        if (x instanceof VatSkExempt) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))))))))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.VatRate (line 17, column 1 - line 17, column 69): " + [ x.constructor.name ]);
    }
};
var showVatRate = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericVatRate)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatAIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatBIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatCIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatDIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatEIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatFIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatGIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatSkNonAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatSkAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatSkSeparateFoodPackagingIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatSkTransportIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VatSkWithoutIsSymbol))(/* #__PURE__ */ genericShowConstructor(VatSkExemptIsSymbol)))))))))))))))
};
var unscrambleDecodeVatRate = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericVatRate)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatAIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatBIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatCIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatDIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatEIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatFIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatGIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatSkNonAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatSkAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatSkSeparateFoodPackagingIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatSkTransportIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatSkWithoutIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(VatSkExemptIsSymbol)))))))))))))))(Unscramble_Enum.defaultEnumOptions)
};
var boundedVatRate = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericVatRate)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(genericTopConstructor)))))))))))))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericVatRate)(genericBottomSum),
    Ord0: function () {
        return ordVatRate;
    }
};
var enumVatRate = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericVatRate)(genericEnumSum1),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericVatRate)(genericEnumSum1),
    Ord0: function () {
        return ordVatRate;
    }
};
var boundedEnumVatRate = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericVatRate)(genericBoundedEnumSum1),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericVatRate)(genericBoundedEnumSum1),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericVatRate)(genericBoundedEnumSum1),
    Bounded0: function () {
        return boundedVatRate;
    },
    Enum1: function () {
        return enumVatRate;
    }
};
var toFillFormTypeVatRate = {
    fillFormDataType: /* #__PURE__ */ Restaumatic_Form_TestHelpers.defaultEnumFillFormDataType(genericVatRate)(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatAIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatBIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatCIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatDIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatEIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatFIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatGIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatSkNonAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatSkAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatSkSeparateFoodPackagingIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatSkTransportIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatSkWithoutIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(VatSkExemptIsSymbol)))))))))))))))
};
var encodeVatRate = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericVatRate)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatAIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatBIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatCIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatDIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatEIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatFIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatGIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatSkNonAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatSkAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatSkSeparateFoodPackagingIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatSkTransportIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatSkWithoutIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(VatSkExemptIsSymbol)))))))))))))))
};
var decodeVatRate = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericVatRate)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatAIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatBIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatCIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatDIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatEIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatFIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatGIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatSkNonAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatSkAlcoholicBeveragesIntendedForHumanConsumptionIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatSkSeparateFoodPackagingIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatSkTransportIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatSkWithoutIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(VatSkExemptIsSymbol)))))))))))))))
};
export {
    VatA,
    VatB,
    VatC,
    VatD,
    VatE,
    VatF,
    VatG,
    VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption,
    VatSkNonAlcoholicBeveragesIntendedForHumanConsumption,
    VatSkAlcoholicBeveragesIntendedForHumanConsumption,
    VatSkSeparateFoodPackaging,
    VatSkTransport,
    VatSkWithout,
    VatSkExempt,
    genericVatRate,
    eqVatRate,
    showVatRate,
    ordVatRate,
    encodeVatRate,
    decodeVatRate,
    unscrambleDecodeVatRate,
    enumVatRate,
    boundedVatRate,
    boundedEnumVatRate,
    toFillFormTypeVatRate
};
